import type { MenuItem } from '../DiscoverySearch';
import type { GroupSearchItem } from './extractGroupSearchItems';

type SearchItem = MenuItem | GroupSearchItem;

const isMenuItem = (item: SearchItem): item is MenuItem => 'onClick' in item;

function sortGroupWithMenuFirst(groupItems: SearchItem[]): SearchItem[] {
  const menuItem = groupItems.find(isMenuItem);
  if (!menuItem) {
    return groupItems;
  }
  const otherItems = groupItems.filter((item) => !isMenuItem(item));
  return [menuItem, ...otherItems];
}

export function groupItemsByTab(
  items: SearchItem[],
  allMenuItems?: MenuItem[],
): SearchItem[] {
  const groupMap = new Map<string, SearchItem[]>();

  for (const item of items) {
    const existing = groupMap.get(item.tabName);
    if (existing) {
      existing.push(item);
    } else {
      groupMap.set(item.tabName, [item]);
    }
  }

  // Inject missing MenuItems for tabs that have matched GroupSearchItems
  if (allMenuItems) {
    for (const [tabName, groupItems] of groupMap) {
      if (!groupItems.some(isMenuItem)) {
        const menuItem = allMenuItems.find((m) => m.tabName === tabName);
        if (menuItem) {
          groupItems.unshift(menuItem);
        }
      }
    }
  }

  return [...groupMap.values()].flatMap(sortGroupWithMenuFirst);
}
